import { render, staticRenderFns } from "./FeaturePopupExpanded.vue?vue&type=template&id=9e996b2c&scoped=true"
import script from "./FeaturePopupExpanded.vue?vue&type=script&lang=js"
export * from "./FeaturePopupExpanded.vue?vue&type=script&lang=js"
import style0 from "./FeaturePopupExpanded.vue?vue&type=style&index=0&id=9e996b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e996b2c",
  null
  
)

export default component.exports